/* ==========================================================================
   Aori K Beauty — collection.js
   Native Shopify storefront filtering + sort + "load more".
   - Filter form (#CollectionFilters) and sort select apply via AJAX: fetch the
     filtered URL, swap #CollectionResults + #CollectionFilters, update counts,
     and push the URL to history. Degrades to a normal form GET with JS off.
   - "Load more" fetches the next paginated page and appends its product cards.
   ========================================================================== */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }

  /* ---- Filtering / sorting (AJAX) -------------------------------------- */

  // Build a URL from the filter form, dropping empty fields.
  function formUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (val, key) {
      if (String(val).trim() !== '') params.append(key, val);
    });
    var q = params.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }

  function applyUrl(url) {
    var results = qs('#CollectionResults');
    if (results) results.classList.add('is-loading');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        ['#CollectionResults', '#CollectionFilters'].forEach(function (sel) {
          var oldN = qs(sel), newN = doc.querySelector(sel);
          if (oldN && newN) oldN.innerHTML = newN.innerHTML;
        });
        ['.coll__count', '.coll__toolbar-count'].forEach(function (sel) {
          var oldN = qs(sel), newN = doc.querySelector(sel);
          if (oldN && newN) oldN.textContent = newN.textContent;
        });
        var oldSort = qs('[data-collection-sort]'), newSort = doc.querySelector('[data-collection-sort]');
        if (oldSort && newSort) oldSort.value = newSort.value;

        // Newly injected cards are above-the-fold candidates — reveal them.
        document.querySelectorAll('#CollectionProductGrid .reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });
        if (results) results.classList.remove('is-loading');
        cacheLabels();
        try { window.history.pushState({ aori: true }, '', url); } catch (e) { /* noop */ }
        document.dispatchEvent(new CustomEvent('collection:updated', { bubbles: true }));
      })
      .catch(function () { window.location.href = url; });
  }

  function initFilters() {
    // Apply on submit (Apply button / Enter in price fields).
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-collection-filters]');
      if (!form) return;
      e.preventDefault();
      applyUrl(formUrl(form));
    });

    // Auto-apply when a checkbox or price field changes; handle sort select.
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-collection-filters]');
      if (form) { applyUrl(formUrl(form)); return; }
      var sortSel = e.target.closest('[data-collection-sort]');
      if (sortSel) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSel.value);
        u.searchParams.delete('page');
        applyUrl(u.toString());
      }
    });

    // Active-filter chips, "clear all", "remove filters" links.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link]');
      if (!link) return;
      e.preventDefault();
      applyUrl(link.getAttribute('href'));
    });

    // Back/forward navigation re-syncs the grid.
    window.addEventListener('popstate', function () { applyUrl(window.location.href); });
  }

  /* ---- Load more ------------------------------------------------------- */

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      var url = btn.getAttribute('href');
      var grid = document.getElementById('CollectionProductGrid');
      if (!url || !grid) return;

      btn.classList.add('is-loading');
      var loadingLabel = btn.getAttribute('data-loading-label');
      if (loadingLabel) btn.textContent = loadingLabel;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('CollectionProductGrid');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (node) {
              var el = node.cloneNode(true);
              el.classList.add('is-visible'); // appended below the fold — show immediately
              grid.appendChild(el);
            });
          }
          var nextBtn = doc.querySelector('[data-load-more]');
          var wrap = btn.closest('.coll__loadmore');
          if (nextBtn) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.classList.remove('is-loading');
            var label = btn.getAttribute('data-label');
            if (label) btn.textContent = label;
          } else if (wrap) {
            wrap.remove();
          }
          // Let other scripts/apps know new products are in the DOM
          document.dispatchEvent(new CustomEvent('collection:appended', { bubbles: true }));
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          // fall back to normal navigation
          window.location.href = url;
        });
    });
  }

  // Cache the original label so we can restore it after loading
  function cacheLabels() {
    document.querySelectorAll('[data-load-more]').forEach(function (b) {
      if (!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent.trim());
    });
  }

  /* ---- Infinite scroll ------------------------------------------------- */
  function initInfiniteScroll() {
    var ticking = false;
    function near(el) {
      var r = el.getBoundingClientRect();
      return r.top <= (window.innerHeight + 700);
    }
    function check() {
      ticking = false;
      var wrap = document.querySelector('[data-collection-results][data-infinite]');
      if (!wrap) return;
      var btn = wrap.querySelector('[data-load-more]');
      if (btn && !btn.classList.contains('is-loading') && near(btn)) btn.click();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Keep loading if the trigger stays in view after products are appended
    document.addEventListener('collection:appended', function () { setTimeout(onScroll, 60); });
    check();
  }

  function boot() { cacheLabels(); init(); initFilters(); initInfiniteScroll(); }
  if (document.readyState !== 'loading') { boot(); }
  else document.addEventListener('DOMContentLoaded', boot);
})();
